const EMAIL_PATTERN = /^[^\s@.]+(?:\.[^\s@.]+)*@[^\s@.]+(?:\.[^\s@.]+)+$/;

export function validateUserCredentials({ email, password, passwordRequired = true }) {
    if (!EMAIL_PATTERN.test((email ?? "").trim())) {
        return "Email invalide : l'adresse email doit contenir un @ et un domaine valide (ex : pharma.fr ou pharma.com).";
    }

    if (!passwordRequired && !password) return null;

    if ((password ?? "").length < 8 || !/[A-Z]/.test(password) || !/\d/.test(password) || !/[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/.test(password)) {
        return "Mot de passe invalide : Le mot de passe doit contenir au moins 8 caractères, une majuscule, un chiffre et un caractère spécial.";
    }

    return null;
}
